export const GA_ID = 'G-TVJT400DNL';

type EventParams = {
  action: string;
  category?: string;
  label?: string;
  value?: number;
};

/** Send a page_view to gtag if available */
export function pageview(path: string) {
  if (typeof window === 'undefined') return;
  // @ts-ignore
  if (typeof window.gtag === 'function') {
    // @ts-ignore
    window.gtag('event', 'page_view', { page_path: path });
  }
}

/** Send a generic event to gtag */
export function trackEvent({ action, category, label, value }: EventParams) {
  if (typeof window === 'undefined') return;
  // @ts-ignore
  if (typeof window.gtag === 'function') {
    // @ts-ignore
    window.gtag('event', action, {
      event_category: category,
      event_label: label,
      value,
    });
  }
}

/** Safe wrapper to call gtag directly (useful in console or ad-hoc) */
export function gtag(...args: any[]) {
  if (typeof window === 'undefined') return;
  // @ts-ignore
  if (typeof window.gtag === 'function') {
    // @ts-ignore
    window.gtag(...args);
  }
}
